import { renderStatusCell } from 'ui/table/StatusCell';

export const renderScheduledTaskStatusCell = renderStatusCell(
    {
        PROCESSED: 'green',
        SCHEDULED: 'yellow',
        QUEUED: 'yellow',
        ERROR: 'red',
        DRAFT: 'grey',
        PROCESSING: 'grey'
    },
    'green'
);
